import { Component} from '@angular/core';
import { ApiService } from './services/api.service';
import packageInfo from '../../package.json';
import { Subscription } from 'rxjs';
import { HeaderService } from './services/header.service';
import { GtmService } from './services/gtm.service';
import version from '../assets/version.json';
import { CookieService } from 'ngx-cookie-service';
import {ClarityService} from "./services/clarity.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false
})
export class AppComponent {

  public version: string = packageInfo.version;
  title = 'standardc-frontend-web';
  createOnlineSub: Subscription;
  public lat;
  public lng;
  zoom;

  constructor(
    private _api: ApiService,
    private headerService: HeaderService,
    private gaService: GtmService,
    private cookieService : CookieService,
    private clarityService: ClarityService
    ) {
        this.gaService.trackEvent('page_view');
        this.createOnlineSub = this._api.createOnline$().subscribe((status) => {
          !status && this._api.openSnackBar('No Internet Connection Available', 'Error')
        });
      }

  ngOnInit() {

    // this.router.events.subscribe(event => {
    //   if (event instanceof RouteConfigLoadStart) {
    //     this.spinner.show();
    //   } else if (event instanceof RouteConfigLoadEnd) {
    //     this.spinner.hide();
    //   }
    // });
    this.clarityService.initClarity();
    this.getVersions();
    sessionStorage.setItem( 'version', packageInfo.version);
    if(packageInfo.version.toString() !== version.build_version.toString()){
      window.location.reload();
      localStorage.clear();
      sessionStorage.clear();
      this.cookieService.deleteAll('/');
    }
    this.getLocation();
    this.headerService.getHeaderData().subscribe((response) => {
      const logoURL = response['data']['static_base_url']+'/'+response['data']['web_hf']['logo_path']+`?timestamp=${new Date().getTime()}`;
      const faviconURL = response['data']['static_base_url']+'/'+response['data']['web_hf']['favicon_path']+`?timestamp=${new Date().getTime()}`;
      const headerContent = response['data']['web_hf']['header'];
      const footerContent = response['data']['web_hf']['footer'];
      const backgroundColor = response['data']['web_hf']['highlight_color'];
      const highLightColor  = response['data']['web_hf']['background_color'];
      const finName = response['data']['web_hf']['bp_business_name'];
      const headerUrl = response['data']['static_base_url']+'/'+response['data']['web_hf']['header_path']+`?timestamp=${new Date().getTime()}`;
      const footerUrl = response['data']['static_base_url']+'/'+response['data']['web_hf']['footer_path']+`?timestamp=${new Date().getTime()}`;
      const bodyUrl = response['data']['static_base_url']+'/'+response['data']['web_hf']['body_path']+`?timestamp=${new Date().getTime()}`;

      // document.documentElement.style.setProperty('--dynamic-bg-color', highLightColor);
      // document.documentElement.style.setProperty('--dynamic-section-bg-color', highLightColor);
      this.setDynamicBgColor(backgroundColor);
      this.setDynamicLabelColor(highLightColor);
      this.setTitleHeader(finName);
      this.setFavicon(faviconURL);
      this.setHeaderBg(headerUrl);
      this.setFooterBg(footerUrl);
      this.setBodyBg(bodyUrl);
      this.setLogo(logoURL);
      this.setHeader(headerContent);
      this.setFooter(footerContent);

    });
  }

  setDynamicBgColor(highLightColor?: string): void {
    const root = document.documentElement;
    if (highLightColor && highLightColor.trim() !== '') {
      root.style.setProperty('--dynamic-bg-color', highLightColor);
    } else {
      root.style.removeProperty('--dynamic-bg-color');
    }
  }

  setDynamicLabelColor(highLightColor?: string) {
    const root = document.documentElement;
    if (highLightColor && highLightColor.trim() !== '') {
      root.style.setProperty('--dynamic-label-color', highLightColor);
    } else {
      root.style.removeProperty('--dynamic-label-color');
    }
  }

  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.lat = position.coords.latitude;
        this.lng = position.coords.longitude;
        this.zoom = 16;
        localStorage.setItem('latitude', this.lat);
        localStorage.setItem('longitude', this.lng);
        console.log("position", position)
      });
    }else{
      console.log("User not allowed")
    }
  }

  setHeaderBg(url: string): void {
    const element = document.getElementById('dynamicHeaderBg');
    if (element) {
      element.style.backgroundImage = `url('${url}')`;
    }
  }

  setFooterBg(url: string): void {
    const element = document.getElementById('dynamicFooterBg');
    if (element) {
      element.style.backgroundImage = `url('${url}')`;
    }
  }

  setBodyBg(url: string): void {
    const element = document.getElementById('dynamicBodyBg');
    if (element) {
      element.style.backgroundImage = `url('${url}')`;
    }
  }

  setLogo(url: string): void {
    const imgElement = document.getElementById('dynamicLogo') as HTMLImageElement;
    if (imgElement) {
        imgElement.src = url;
        imgElement.alt = 'Logo';
    }
  }

  setFavicon(url: string): void {
    const favicon = document.getElementById('dynamicFavicon') as HTMLLinkElement;
    if (favicon) {
      favicon.href = url;
    }
  }

  setHeader(header: string): void {
    const headerTitle = document.getElementById('dynamicHeader');
    if (headerTitle) {
      headerTitle.innerHTML = header;
    }
  }

  setFooter(footer: string): void {
    const footerTitle = document.getElementById('dynamicFooter');
    if (footerTitle) {
      footerTitle.innerHTML = footer;
    }
  }

  setTitleHeader(header: string): void {
    const headerTitle = document.getElementById('dynamicTitle');
    if (headerTitle) {
      headerTitle.innerHTML = header;
    }
  }

  ngOnDestroy(): void {
    if (this.createOnlineSub) {
      this.createOnlineSub.unsubscribe();
    }  }
  getVersions(){
    this._api.functionGET('version').subscribe((response)=>{
      sessionStorage.setItem('server_version' , JSON.stringify(response['data']));
    });
  }

}
